import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Image from 'next/image';
import { motion } from 'framer-motion';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const products = [
  { id: 1, name: 'Product 1', image: '/assets/carousel/image1.webp', text: 'Dream Fashion To Reality' },
  { id: 2, name: 'Product 2', image: '/assets/carousel/image2.webp', text: 'Eco Friendly Products' },
  { id: 3, name: 'Product 3', image: '/assets/carousel/image3.webp', text: 'Dream Fashion To Reality' },
  { id: 4, name: 'Product 4', image: '/assets/carousel/image4.webp', text: 'Eco Friendly Products' },
  { id: 5, name: 'Product 5', image: '/assets/carousel/image5.webp', text: 'Dream Fashion To Reality' },
];

const CustomPrevArrow = ({ onClick }: { onClick?: () => void }) => (
  <button className="carousel-arrow carousel-arrow--prev" onClick={onClick} aria-label="Previous slide" type="button">
    <LeftOutlined />
  </button>
);

const CustomNextArrow = ({ onClick }: { onClick?: () => void }) => (
  <button className="carousel-arrow carousel-arrow--next" onClick={onClick} aria-label="Next slide" type="button">
    <RightOutlined />
  </button>
);

const settings = {
  dots: true,
  infinite: true,
  speed: 1200,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
  cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  accessibility: true,
  focusOnSelect: true,
  pauseOnHover: false,
  pauseOnFocus: true,
  lazyLoad: 'progressive' as const,
};

const HomeCarousel = () => (
  <section className="home-carousel" aria-label="Featured products carousel">
    <Slider {...settings}>
      {products.map((product, index) => (
        <div key={product.id} className="carousel-slide" role="tabpanel" aria-label={`Slide ${index + 1} of ${products.length}`}>
          <div className="carousel-slide__image">
            <Image 
              src={product.image} 
              alt={product.name} 
              fill 
              style={{ objectFit: 'cover' }}
              priority={index === 0}
            />
            <div className="carousel-slide__overlay" />
          </div>
          <motion.div 
            className="carousel-slide__content"
            initial={{ opacity: 0, y: 60, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ 
              duration: 1.2, 
              delay: 0.3,
              ease: [0.25, 0.46, 0.45, 0.94]
            }}
          >
            <h2 className="carousel-slide__text">{product.text}</h2>
          </motion.div>
        </div>
      ))}
    </Slider>
  </section>
);

export default HomeCarousel;
